import React, {useState} from 'react';
import PeliculaCard from './peliculaCard'
export default function FormBuscador(){
    
    //states - input de la query 
    const[query, setQuery] = useState('');
    
    //state , peliculas a renderizar
    const [peliculas, setPeliculas] = useState([]);


    const buscarPeliculas = async (e) => {
        e.preventDefault();

        
        const token = '674a6ef5377de277c8d3a10076bca897';
        
        const url = `https://api.themoviedb.org/3/search/movie?api_key=${token}&language=es-ES&query=${query}&include_adult=false&sort_bypopularity.desc`;

        try{
            const res = await fetch(url);
            const data = await res.json();
            setPeliculas(data.results);
            
        }catch(error){
            console.log(error)
        }

    }

    return (
        <>
            <form className="form" onSubmit={buscarPeliculas}>
                <label htmlFor="query" className="label">Titulo Pelicula</label>
                <input type="text" name="query" className="input" placeholder="i.e. Star Wars"
                value={query} onChange={(e)=> setQuery(e.target.value)}></input>
                <button className="button" type="submit">Buscar</button>
            </form>
            <div className="card-list">
                {peliculas.filter(pelicula => pelicula.poster_path).map(pelicula => (
                    <PeliculaCard pelicula={pelicula} key={pelicula.id} />
                ))}
            </div>
        </>
    )
}

